var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KpTooltip',{attrs:{"disabled":!_vm.tooltip},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({class:_vm.classObject,attrs:{"title":_vm.title}},'v-icon',{ ..._vm.$attrs, ...attrs },false),{ ..._vm.$listeners, ...on }))]}}])},[_vm._v(" "+_vm._s(_vm.tooltip || null)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }